const translationJsonObj = require('libs-content-helper').EsTranslations;

var translationJson = {
  "LEARNER": {
    "ACTIVITYLAUNCH": {
      "_url": "https://nemo2.comprodls.com/:spaceid/product/:productcode",
      "DOWNLOAD_INSTRUCTIONS1": "Descarga el/la",
      "DOWNLOAD_INSTRUCTIONS2": "a continuación y completa esta actividad",
      "DOWNLOAD": "Descargar",
      "SUBMITTED_FOR_MARKING": "Entregado/a",
      "FEEDBACK_READY_MSG": "Te avisaremos cuando tu profesor haya calificado tu trabajo",
      "SUBMITTED": "Entregado/a",
      "ARE_YOU_READY_TO_SUBMIT": "¿Listo para entregar?",
      "ARE_YOU_READY_TO_SUBMIT_GROUP":"¿Listo para entregar el trabajo de tu grupo?",
      "NO_FURTHER_CHANGES_ALLOWED_MESSAGE": "No olvides que, una vez entregado, ya no podrás implementar ningún cambio en tu trabajo",
      "NO_FURTHER_CHANGES_ALLOWED_GROUP_MSG": "Estás actuando en nombre de todos los integrantes del grupo. Ya no podrás implementar ningún cambio en el trabajo a menos que el profesor lo pida.",
      "CANCEL": "Cancelar",
      "SUBMIT": "Enviar",
      "YES_SUBMIT": "Sí, entregar",
      "CLASS_NOT_STARTED_MSG": "Tu clase aún no ha comenzado",
      "SAVE_DRAFT_AFTER_CLASS_STARTS": "Puedes guardar un borrador ahora y enviarlo a tu profesor cuando comience tu clase",
      "SAVE": "Guardar",
      "SAVED": "Guardado",
      "AUTO_SAVED": "Guardado automáticamente",
      "COMPLETED": "Completado/a",
      "START_RECORDING_MSG1": "Tocar para comenzar a grabar",
      "START_RECORDING_MSG2": "Podrás reproducirlo una vez que se haya detenido",
      "PLAY_RECORDING_MSG1": "Reproducir la grabación",
      "PLAY_RECORDING_MSG2": "Tiempo de grabación: {{elapsedTime}}",
      "STOP_PLAYING_MSG1": "Parar la reproducción",
      "STOP_PLAYING_MSG2": "Tiempo: {{audioSeeker}}/{{duration}}",
      "START_NEW_RECORDING_MSG1": "Iniciar una grabación nueva",
      "START_NEW_RECORDING_MSG2": "Reemplazará a la anterior",
      "RECORDING": "Grabando",
      "STOP_RECORDING_MSG1": "Parar la grabación",
      "STOP_RECORDING_MSG2": "Tiempo transcurrido: {{elapsedTime}}",
      "SEC_LEFT": " segundos restantes",
      "SUBMITTING_MSG1": "Enviando grabación ...",
      "SAVING_MSG1": "Guardando grabación ...",
      "PROCESSING_MSG": "Processing recording ...",
      "SUBMITTED_RECORDING": "Reproducir la grabación",
      "RECORDED": "Grabando",
      "FORGIVE_US_TEXT_MSG1": "Lamentablemente,",
      "RECORDING_NOT_POSSIBLE_MSG1": "no podemos grabar tu trabajo en este momento",
      "RECORDING_NOT_POSSIBLE_MSG2": "Puede deberse a que no estás en línea, a que tu micrófono no está conectado, o a que tu navegador no permite la grabación. Verifica que estás en línea, y que tu micrófono está prendido, o intenta nuevamente utilizando un navegador diferente (sugerimos Chrome, Firefox o Safari), y/o un dispositivo diferente (tablet o PC de escritorio).",
      "OK": "OK",
      "NEXT": "Próximo",
      "CHECK": "Verificar",
      "PREVIOUS": "Anterior",
      "FIRST_ATTEMPT":"Primer intento",
      "SECOND_ATTEMPT":"Segundo intento",
      "THIRD_ATTEMPT":"Tercer intento",
      "SCORE":"Puntaje:",
      "NO_FEEDBACK": "Sin observaciones:",
      "MARKED_AT": "{{elapsedTime}} hasta {{timestamp}} marcado",
      "MARK" : "Puntaje:",
      "FEEDBACK" : "Comentarios:",
      "NEW_SUBMISSION_REQUESTED": "Nueva entrega solicitada",
      "WORD_COUNT": "Recuento de palabras:",
      "WORDS": "palabras",
      "ANSWER": "Respuesta:",
      "ANSWER_LABEL": "Respuesta",
      "TYPE_HERE": "Escribe aquí...",
      "NEXT_ACTIVITY": "ACTIVIDAD SIGUIENTE",
      "REVIEW": "CRÍTICA",
      "BACK": "ATRÁS",
      "TITLE" : "Tarea colaborativa",
      "MODAL_PLACEHOLDER" : "Esta es una tarea colaborativa en la que los alumnos asignados a un grupo trabajan juntos para completar una actividad. Para hacerlo, los alumnos deben formar parte de un grupo .",
      "ARCHIVED_SUBMITTED_LOCK_VERSION_MSG" : "Esta actividad está bloqueada porque el grupo que trabajó en ella ahora está archivado, pero todavía pueden verse los comentarios del grupo.",
      "ARCHIVED_LOCK_VERSION_MSG" : "Esta actividad está bloqueada porque el grupo que trabajó en ella ahora está archivado.",
      "DISABLE_GROUP_INFO_MSG" : "Esta es una actividad colaborativa. Solo pueden completarla alumnos asignados a grupos por un profesor.",
      "ON_BEHALF_OF": "en nombre de",
      "ON_BEHALF_OF_STUDENT_NOT_PRESENT": "Un alumno que no forma parte del grupo entregó en nombre de",
      "GROUP_PSKILL_TITLE": "Título:",
      "ADD_LINK": "Agregar vínculo",
      "EDIT_LINK": "Editar vínculo",
      "REMOVE_LINK": "Eliminar vínculo",
      "URL": "URL",
      "URL_PLACEHOLDER": "Introducir el vínculo de destino",
      "URL_REQUIRED": "URL es obligatorio",
      "URL_INVALID": "Introducir un URL válido",
      "URL_HELP_TEXT": "(se permite un máximo de 256 caracteres)",
      "OPTIONAL_TEXT": "Texto a mostrar (optativo)",
      "OPTIONAL_TEXT_PLACEHOLDER": "Introducir el texto a mostrar",
      "UPDATE_LINK": "Editar vínculo",
      "ARE_YOU_SURE": "¿Estás seguro?",
      "LINK_WILL_REMOVED": "El vínculo quedará eliminado.",
      "KEEP_LINK": "Mantener.",
      "CONFIRM_LINK_DELETE": "Sí, borrar",
      "MOCK_IN_PROGRESS_TEXT": "En desarrollo",
      "MOCK_AWAITING_SCORE_TEXT": "Prueba completada, a la espera de puntajes",
      "MOCK_COMPLETED_SCORE_LABEL": "Puntaje",
      "NO_TEST_TYPE_ERROR": "Error: This test is not associated with a 'Test type'. Please associate a 'Test type'.",
      "PRODUCTIVESKILL_SUBMIT_DISABLE_TOOLTIP": "You will be able to submit this activity when a teacher is added to your class",
      "READ_CONVERSATION": "Read conversation",
      "SEE_TOPICS": "See topics",
      "BACK_TO_ASSIGNMENTS": "Back to assignments",
      "SCREEN_READER": {
        "CROSS": "Cerrar",
        "HELP": "Ayuda",
        "SUBMIT_ANSWERS_FOR_MARKING": "Enviar",
        "SEND_SCORES": "Enviar puntajes",
        "GOTO_NEXT_SCREEN": "Pasar a la pantalla siguiente",
        "GO_TO_UNIT_VIEW": "Ir a vista de unidad",
        "CLOSE_TOC": "Cerrar tabla de contenido",
        "GO_BACK_ASSIGNMENTS": "Volver a la página de tareas",
        "OPEN_TOC": "Abrir tabla de contenido",
        "DOWNLOADABLE_ITEM": "Esto puede descargarse",
        "BOLD": "Negrita",
        "ITALIC": "Bastardilla",
        "UNDERLINE": "Subrayar",
        "GROUP_INFO": "Información sobre el grupo",
        "CLOSE_GROUP_INFO": "Cerrar ventana emergente de información sobre el grupo",
        "OPEN_LINK": "Abrir vínculo:",
        "SHOW_LINK_OPTIONS": "Mostrar opciones de vínculos",
        "CANCEL_DELETE_LINK": "Cancelar eliminación de vínculo",
        "STATUS_IN_PROGRESS": "Activity status: in progress",
        "ACTIVITY_SCREEN_STATUS": "Exercise {{currentScreen}} of {{totalScreens}}",
        "ACTIVITY": "Actividad: {{activityName}}"
      }
    },
    "CREATE_USER_ANALYTICS": {
      "WELCOME_TEXT": "Welcome to your Cambridge One",
      "DESCRIPTION_TEXT": "We’re setting up the learning materials for you",
  },
    "_COMMON_ACROSS_PAGES": {
      "HEADER": {
        "MY_PROFILE": "Mi perfil",
        "LOGOUT": "Cerrar sesión",
        "CONTENT": "Contenido"
      }
    }
  },
  "TEACHER": {
    "PRODUCT_VIEW": {
      "BANNER_MESSAGE": "{{activatedProductTitles}} for {{bundleTitle}} activated",
      "PEAS_BANNER_MESSAGE": "{{peasBundleTitle}} activated",
      "PEAS_BANNER_MESSAGE_STARTED": "{{peasBundleTitle}} started",
      "SCREEN_READER": {
        "GO_BACK_BUNDLE": "Go back to learning materials page",
        "GO_BACK_CLASS_PAGE": "Go back to class materials page",
        "GO_BACK_DASHBOARD": "Go back to dashboard",
      }
    },
    "CREATE_ASSIGNMENTS": {
      "SELECT_CONTENT": "Select content",
      "MORE_INFORMATION": "More information",
      "UNIT_DEEPLINK_TOOLTIP_TEXT": "select one or more whole units to create a link to each of them (one link per unit)",
      "UNIT_DEEPLINK_TOOLTIP_TEXT_SPEAKING_COMPANION": "select one or more whole categories to create a link to each of them (one link per category)",
      "CUSTOM_DEEPLINK_TOOLTIP_TEXT": "select a list of lessons and/or activities to create a single custom link to all of them",
      "CUSTOM_DEEPLINK_TOOLTIP_TEXT_SPEAKING_COMPANION": "select a list of sub-categories and/or topics to create a single custom link to all of them",
      "BY_UNIT": "By unit",
      "BY_CATEGORY": "By category",
      "CUSTOMISED": "Customised",
      "MANAGE_CUSTOM_LINKS": "Manage custom links",
      "MAX_CUSTOM_LINKS_HEADING": "Maximum number of custom links created",
      "MAX_CUSTOM_LINKS_DESC": "Your class has already reached the maximum number of 150 custom links. Delete a custom link to create again.",
      "MAX_ASSIGNED_ACTIVITIES_HEADING": "Activities limit reached",
      "MAX_ASSIGNED_ACTIVITIES_DESC": "You have reached the limit of assigned activities and will need to delete old custom links before you can add more. Go to 'Manage custom links' to delete old links and free up space.",
      "VIEW_CUSTOM_LINKS": "View custom links",
      "NEXT": "Próximo",
      "UPDATE": "Update",
      "CHECK": "Verificar",
      "REVIEW": "CRÍTICA",
      "PREVIOUS": "Previous",
      "NEXT_ACTIVITY": "ACTIVIDAD SIGUIENTE",
      "ACTIVITIES": "actividades",
      "ACTIVITY": "actividad",
      "YOU_HAVE": "You have",
      "SELECTED": "seleccionado/a/s",
      "ASSIGN_TO_CLASS": "Asignar a:",
      "ASSIGN_TO_CLASS_SUCCESS": "asignado/a a",
      "NO_ITEMS_LEFT_TO_ASSIGN": ". No more content left to assign.",
      "FOC_NO_ITEMS_LEFT_TO_ASSIGN": ". No more content left to assign",
      "ALL_STUDENTS" : "todos los alumnos",
      "ASSIGNMENT_NAME": "Nombre de tarea",
      "LINK_NAME": "Link name",
      "ASSIGNMENT_DUE_DATE": "Fecha de entrega de tarea",
      "PREV": "Ant.",
      "ASSIGN": "Asignar",
      "CREATE": "Create",
      "CANCEL": "Cancelar",
      "EDITED": "Edited",
      "CONFIRM_DELETE_MESSAGE": "Are you sure you want to delete?",
      "SET_ASSIGNMENT": "Asignar tarea",
      "CREATE_CUSTOM_LINK": "Create custom link",
      "EXIT": "Salir",
      "ASSIGN_NEW": "Asignar nueva",
      "CREATE_NEW_ASSIGNMENT": "Asignar nueva",
      "START_DATE_ASSIGN": "From {{startDate}} at {{startTime}}",
      "END_DATE_ASSIGN": "to {{endDate}} at {{endTime}}",
      "PREVIOUSLY_ASSIGNED": "Previously assigned",
      "DUE": "Fecha de entrega",
      "START_DATE": "Start date",
      "DUE_DATE": "Due date",
      "LOCK_CONTENT": "Lock access to assignment content after due date",
      "STUDENT_ACCESS": "Student access after due date",
      "ACCESS_LOCKED": "Locked",
      "ACCESS_UNLOCKED": "Unlocked",
      "NO_GROUP_INFO_TITLE":"Este material incluye actividades colaborativas",
      "NO_GROUP_INFO_MSG":"Todavía no se ha creado ningún grupo para esta clase. Debes crear grupos y agregarles alumnos para que puedan completar esta actividad.",
      "NO_CUSTOM_LINKS_HEADING": "You have no custom links yet",
      "NO_CUSTOM_LINKS_DESC": "Select a list of lessons and/or activities to create a single custom link to all of them",
      "ADD_LINK": "Create link",
      "ADD_LINKS": "Create links",
      "RE_LINK": "Re-link",
      "DELETE": "Delete",
      "RULES_WARNING_HEADING": "Did you want to assign locked content?",
      "RULES_WARNING_TEXT": "These activities are locked by an access rule. If you assign them to your class they will automatically be unlocked to give your students access for the duration of the assignment",
      "VIEW_DETAILS": "View details",
      "HIDE_DETAILS": "Hide details",
      "VIEW_RULES_LIST": "View list of access rules",
      "LOCKED_FROM": "Locked from {{startDate}} at {{startTime}} to {{endDate}} at {{endTime}}",
      "AND": " and ",
      "ASSIGNMENT_CREATED": "Assignment created",
      "ASSIGNMENT_AND_RULE_CREATED": "Assignment and lock access rule created",
      "RULE_DUE_DATE_INFO": "until {{dueDate}}",
      "ASSIGNMENT_UPDATED": "Assignment updated",
      "ASSIGNMENT_AND_RULE_UPDATED": "Assignment and access rule updated",
      "REVIEW_ASSIGNMENT": "Review created assignments",
      "RETURN_PRESENTATION_PLUS": "Return to Presentation Plus",
      "RETURN_EBOOK": "Return to eBook",
      "SELECT_ALL": "Select all",
      "RULE_LIMIT_ERROR": "Limit reached: {{limit}} rules for {{componentName}}",
      "RULE_SIZE_ERROR": "Rule cannot be created",
      "RULE_LIMIT_ERROR_MESSAGE_1": "Your assignment has been created, but the lock access rule could not be applied.",
      "RULE_LIMIT_ERROR_MESSAGE_2": "To enable locking access after the due date, remove at least one rule linked to {{componentName}}",
      "RULE_LIMIT_EDIT_ERROR_MESSAGE": "Your assignment has been edited, but the lock access rule could not be applied.",
      "RULE_CREATION_ERROR": "Lock access rule could not be applied",
      "RULE_CREATION_ERROR_MESSAGE_1": "Your assignment has been created, but the lock access rule could not be applied due to a technical issue.",
      "RULE_CREATION_ERROR_MESSAGE_2": "Continue without it, or try again",
      "RULE_EDIT_ERROR_MESSAGE_1": "Your assignment has been edited, but the lock access rule could not be applied due to a technical issue.",
      "RULE_DELETE_ERROR": "Lock access rule could not be removed",
      "RULE_DELETE_ERROR_MESSAGE_1": "Your assignment has been updated, but the lock access rule could not be removed due to a technical issue.",
      "RULE_DELETE_ERROR_MESSAGE_2": "Continue without removing it, or try again",
      "RULE_UPDATE_ERROR": "Lock access rule could not be updated",
      "RULE_UPDATE_ERROR_MESSAGE_1": "Your assignment has been edited, but the lock access rule could not be updated due to a technical issue.",
      "RULE_UPDATE_ERROR_MESSAGE_2": "Continue without it, or update the lock rule manually",
      "CONTINUE_WITHOUT_LOCK": "Continue without locking",
      "DELETE_EXISTING_RULE": "Delete an existing rule",
      "CREATE_LOCK_RULE": "Create lock access rule",
      "CONTINUE_WITHOUT_REMOVING": "Continue without removing",
      "CONTINUE_WITHOUT_UPDATING": "Continue without updating the lock rule",
      "UPDATE_LOCK_RULE": "Update lock access rule",
      "DELETE_LOCK_RULE": "Delete lock access rule",
      "BACK_TO_ACTIVITIES": "Back to activities",
      "BACK_TO_TESTS": "Back to tests",
      "BACK_TO_ASSIGNMENT_DETAILS": "Back to assignment details",
      "BACK_TO_SELECT_STUDENTS": "Back to student selection",
      "BACK_TO_ASSIGNMENT_CREATION_SUMMARY": "Back to summary",
      "BACK_TO_ASSIGNMENTS": "Back to assignments",
      "KEEP_EDITING": "Keep editing",
      "ASSIGNMENT_SUMMARY": "Assignment summary",
      "ASSIGNMENT_CONTENT": "Assignment content",
      "ASSIGNMENT_DETAILS": "Assignment details",
      "EDIT_ASSIGNMENT": "Edit",
      "DISABLED_EDIT_BUTTON_MESSAGE": "You need to have students in this class first before you can edit",
      "EDIT_ASSIGNMENT_INFO": "You are making changes to an active assignment, students will be notified.",
      "STUDENTS_TITLE": "Students",
      "STUDENTS": "students",
      "STUDENT": "student",
      "START_DATE_TIME": "Start date and time",
      "DUE_DATE_TIME": "Due date and time",
      "NAME": "Name",
      "WARNING_LEAVE_THIS_PAGE": "Are you sure you want to leave this page?",
      "WARNING_CANCEL": "Are you sure you want to cancel?",
      "WARNING_MODAL_TEXT": "All progress will be lost",
      "DUE_DATE_WARNING": "The due date is in the past",
      "DUE_DATE_WARNING_TEXT": "Change the due date to update the assignment",
      "EDIT_DUE_DATE": "Edit due date",
      "CANCEL_CHANGES": "Cancel changes",
      "GO_BACK": "No, go back",
      "GO_BACK_BUTTON": "Go back",
      "CONFIRM_CANCEL": "Yes, cancel",
      "CONFIRM_LEAVE_THIS_PAGE": "Yes, leave this page",
      "ENTER_ASSIGNMENT_DETAILS": "Enter assignment details",
      "SELECT_ALL_STUDENTS": "All students",
      "SELECT_STUDENTS": "Select students",
      "NO_LEARNER_PLACEHOLDER1": "You haven't added any students to this class yet",
      "NO_LEARNER_PLACEHOLDER2": "The assignment will be automatically set to students when they join the class",
      "VIEW_SUMMARY": "View summary",
      "CREATE_ANOTHER_ASSIGNMENT": "Create another assignment",
      "ASSIGNMENT_LIMIT_TITLE": "Assignment limit reached",
      "ASSIGNMENT_LIMIT_DESC": "You have reached the maximum number of assignments for this class. Please delete at least one assignment to create a new one",
      "CLOSE": "Close",
      "READ_CONVERSATION": "Read conversation",
      "ASSIGNMENT_LO_LIMIT_MODAL": {
        "LIMIT": "Limit reached",
        "WARNING_TEXT1": "You have reached the limit of assigned activities in the class",
        "WARNING_TEXT2": "Please delete an assignment to assign more activities",
        "LIMIT_LTI": "Activities limit reached",
        "WARNING_TEXT1_LTI": "You have reached the limit of assigned activities and will need to delete old custom links before you can add more.",
        "WARNING_TEXT2_LTI": "Go to 'Manage custom links' to delete old links and free up space",
        "MANAGE_CUSTOM_LINKS": "Manage custom links"
      },
      "UPDATED_CONTENT_BANNER": {
        "CONTENT_UPDATED_MESSAGE": "Assignment successfully updated",
        "DETAILS_UPDATED_MESSAGE": "Assignment successfully updated",
        "STUDENT_UPDATED_MESSAGE": "Students successfully updated",
        "CLOSE_SUCCESS_MESSAGE": "Close banner"
      },
      "SCREEN_READER": {
          "ENTER_LINK_NAME": "Enter link name",
          "ENTER_ASSIGNMENT_START_DATE": "Enter assignment start date",
          "ENTER_ASSIGNMENT_DUE_DATE": "Enter assignment due date",
          "SELECT_UNIT_DEEPLINK": "Select to create unit deeplinks",
          "SELECT_CUSTOM_DEEPLINK": "Select to create custom deeplinks",
          "SUBMIT_ANSWERS_FOR_MARKING": "Enviar",
          "GOTO_NEXT_SCREEN": "Pasar a la pantalla siguiente",
          "OPEN_TOC": "Abrir tabla de contenido",
          "GO_TO_UNIT_VIEW": "Ir a vista de unidad",
          "GO_BACK": "Go back to create assignment",
          "NEXT": "Next",
          "CANCEL_BUTTON": "Cancel Button",
          "CLOSE_POP_UP": "Cerrar ventana emergente",
          "CLOSE_SIDEBAR": "Cerrar barra lateral",
          "SELECT_LESSON": "Seleccionar lección para crear la tarea",
          "LESSON_INCLUDED_SUCCESS": "Lección incluida con éxito en la tarea",
          "SELECT_ACTIVITY": "Seleccionar actividad para crear la tarea",
          "ACTIVITY_INCLUDED_SUCCESS": "Actividad incluida con éxito en la tarea",
          "PROCESSING": "Procesando",
          "NO_CUSTOM_LINKS_ICON": "No custom links icon",
          "NAVIGATE_BACK_TO_DASHBOARD": "Volver a página del tablero",
          "NO_GROUP_WARNING": "Aviso de que no hay grupos",
          "SELECT_UNIT": "Select Unit",
          "CLOSE_UNITVIEW_SIDEBAR": "Close table of contents",
          "GO_TO_COMPONENT_VIEW": "Go back to component selection page",
          "GO_TO_SELECT_CONTENT_VIEW": "Go back to select content page",
          "GO_BACK_TO_ACTIVITIES": "Go back to activities",
          "SELECT_STUDENT": "Select student",
          "ENTER_ASSIGNMENT_NAME": "Introducir nombre de tarea asignada"
      }
    },
    "_COMMON_ACROSS_PAGES": {
      "HEADER": {
        "JOIN_NEW_SCHOOL": "Integración al centro educativo",
        "CONTENT": "Contenido",
        "SCREEN_READER": {
          "CAMBRDIGE_LOGO": "Cambridge One Home"
        },
        "HELP": "Ayuda",
        "HELP_CENTRE": "Help centre",
        "TUTORIALS": "Tutoriales",
        "UNDERSTANDING_CODES_AND_KEYS": "Comprender códigos y claves",
        "ACTIVATING_COURSE_MATERIALS": "Activar materiales del curso",
        "CREATING_A_CLASS": "Crear una clase",
        "ADDING_STUDENTS_TO_A_CLASS": "Agregar estudiante a la clase",
        "CREATING_ASSIGNMENTS": "Crear tareas",
      }
    },
    "CREATE_ACCESS": {
      "SELECT_ALL": "Select all",
      "CONTINUE": "Continue",
      "CONTENTS": "Contents",
      "RESET_SELECTION": "Re-set",
      "CLEAR_SELECTION": "Clear selection",
      "UPDATE": "Update",
      "SET_RULE_PAGE": {
        "PRODUCT_NAME": "Create a rule for {{productTitle}}",
        "PRODUCT_NAME_UPDATE": "Edit rule for {{productTitle}}",
        "RULE_SELECTION_MSG": "I want the selected content to",
        "UNLOCK_WARNING_MSG": "Unlock rules will override any existing or future lock rules",
        "LOCK": "Lock",
        "UNLOCK": "Unlock",
        "RULE_TITLE_TEXT": "Rule title (Optional)",
        "RULE_TITLE_PLACEHOLDER": "Enter a rule title",
        "TOOLTIP_TEXT": "You can use the Rule title to describe your rule (e.g. Mid-term content, Units 1-3, Restricted activities)",
        "SCHEDULE": "Schedule",
        "CLASS_PERIOD": "Class period:",
        "START_DATE_LABEL": "Start date",
        "SET_END_DATE_LABEL": "Set an End date",
        "END_DATE_LABEL": "End date",
        "STUDENTS_INFO": "Students ({{studentCount}})",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SELECT_ALL": "Select all",
        "NO_LEARNER_PLACEHOLDER": "You haven't added any students to this class yet",
        "EXIT": "Exit",
        "CREATE_ANOTHER_RULE": "Create another rule",
        "LOCK_RULE_CREATED_MSG": "You have successfully locked the selected content for all students",
        "UNLOCK_RULE_CREATED_MSG": "You have successfully unlocked the selected content for all students",
        "LOCK_RULE_CREATED_MSG_INDIVIDUAL": {
            "SINGULAR": "You have successfully locked the selected content for {{learnersCount}} student",
            "PLURAL": "You have successfully locked the selected content for {{learnersCount}} students",
        },
        "UNLOCK_RULE_CREATED_MSG_INDIVIDUAL": {
            "SINGULAR": "You have successfully unlocked the selected content for {{learnersCount}} student",
            "PLURAL": "You have successfully unlocked the selected content for {{learnersCount}} students",
        },
        "RULE_UPDATED_MSG": "You have successfully updated this access rule",
        "ACCESS_RULE_CREATED_MSG": "Access rule created!",
        "ACCESS_RULE_UPDATED_MSG": "Access rule updated!",
        "CONTINUE_EDITING": "Continue editing",
        "ASSIGNMENTS_WARNING_HEADING": "This content is included in a current assignment. It can't be locked until that ends",
        "VIEW_DETAILS": "View details",
        "HIDE_DETAILS": "Hide details",
        "VIEW_ASSIGNMENTS": "View assignments list",
        "ASSIGNED_FROM": "Assigned from {{assignmentStartDate}} at {{assignmentStartTime}} to {{assignmentDueDate}} at {{assignmentDueTime}}",
        "LEAVE_THIS_PAGE": "Leave this page?",
        "LEAVE_CREATE_PAGE_MSG": "You have not finished creating this rule",
        "LEAVE_WITHOUT_SAVING": "Leave without saving",
        "BACK_TO_CREATING": "Back to creating",
        "LEAVE_EDIT_PAGE_MSG": "You have not finished editing this rule",
        "BACK_TO_EDITING": "Back to editing",
        "RULES_WARNING_HEADING": "This content has existing rules",
        "RULES_WARNING_TEXT": "The content you selected already has rules associated with it",
        "VIEW_RULES_LIST": "View detailed list of access rules",
        "LOCKED_FROM": "Locked from {{startDate}} at {{startTime}}",
        "AND": " and ",
        "UNLOCKED_FROM": "Unlocked from {{startDate}} at {{startTime}} to {{endDate}} at {{endTime}}",
        "NOTIFICATIONS": "Notifications",
        "NOTIFICATION_BEFORE_START_DATE": "Send a reminder to students on the day before the rule start date",
        "NOTIFICATION_ON_START_DATE": "Send a reminder to students on the rule start date",
        "NOTIFICATION_BEFORE_END_DATE": "Send a reminder to students on the day before the rule end date",
        "RULE_LIMIT_MSG": "You have reached the limit of {{ruleLimit}} rules allowed for",
        "RULES_EXCEED_HEADING": "Rule cannot be created",
        "MAX_RULE_SIZE": "You have reached the maximum number of rule items for this material",
        "GO_BACK": "Go back",
        "SCREEN_READER": {
          "SELECT_STUDENT": "Select student",
          "PROCESSING": "Processing",
          "CLOSE": "Close"
        }
      },
      "SCREEN_READER": {
        "SELECT_ALL_UNIT": "Select all units",
        "SELECT_ALL_LESSON": "Select all lessons"
      },
      "UPDATE_CONTENTS_BANNER": {
        "UPDATE_MSG": "Selected content updated!",
        "SCREEN_READER": {
          "CLOSE": "close"
        }
      }
    },
    "GRADE_ACTIVITY_SELECTION": {
      "PREVIEW_PART1": "Desactiva las actividades que quieres excluir del cálculo de la calificación",
      "PREVIEW_PART2": "También podrás hacer click en el título de la actividad para verla",
      "SAVE": "Guardar",
      "WARNING_MODAL_TEXT1": "¿Estás seguro de querer volver atrás?",
      "CANCEL_WARNING_MODAL_TEXT": "¿Estás seguro de querer cancelar?",
      "WARNING_MODAL_TEXT2": "Se perderán todos los cambios que no hayas guardado",
      "GO_BACK": "Sí, volver atrás",
      "CONTINUE_EDITING": "No, seguir editando",
      "NO_GO_BACK": "No, volver atrás",
      "YES_CANCEL": "Sí, cancelar",
      "CONFIRMATION_MODAL_HEADING": "Selección de contenido actualizada",
      "CONFIRMATION_MODAL_TEXT": "Has seleccionado {{selectedActivities}} de {{totalActivities}} de {{materialName}}: {{componentName}}",
      "BACK_TO_GRADE_WEIGHTING": "Volver a pautas de calificación de la clase",
      "SCREEN_READER": {
        "CLOSE": "Cerrar"
      }
    },
    "GENERIC_ERROR_MODAL": {
      "ERROR_MODAL_TEXT": "Lamentablemente, algo salió mal. No se guardaron tus cambios",
      "TRY_AGAIN_BTN": "Vuelve a intentar",
      "SCREEN_READER": {
        "CLOSE": "Cerrar"
      }
    }
  },
  "_COMMON_ACROSS_MODULES": {
    "FOOTER": {
      "TERMS_OF_USE": "Términos de uso",
      "PRIVACY_POLICY": "Aviso de privacidad",
      "ACCESSIBILITY": "Accesibilidad",
      "SYSTEM_STATUS": "Estado del sistema",
      "OUR_APPROACH": "Our approach",
      "HELP": "Ayuda",
      "CAMBRDIGE_UNIVERSITY_PRESS": "Cambridge University Press & Assessment",
      "INSTITUTION_REQUEST": "Cambridge One para centros educativos",
      "FAQ": "FAQs"
    }
  },
  "SHARED": {
    "ACTIVITY_QUESTION": {
      "SCREEN_READER": {
          "CROSS": "Cerrar",
          "HELP": "Ayuda",
      }
    },
    "COLLAB" : {
      "SHOW_INSTRUCTION": "Mostrar instrucciones",
      "HIDE_INSTRUCTIONS": "Ocultar instrucciones",
      "TITLE" : "Tarea colaborativa",
      "MODAL_PLACEHOLDER" : "Esta es una tarea colaborativa en la que los alumnos asignados a un grupo trabajan juntos para completar una actividad. Para hacerlo, los alumnos deben formar parte de un grupo .",
      "ARCHIVED_SUBMITTED_LOCK_VERSION_MSG" : "Esta actividad está bloqueada porque el grupo que trabajó en ella ahora está archivado, pero todavía puedes ver los comentarios del grupo.",
      "ARCHIVED_LOCK_VERSION_MSG" : "Esta actividad está bloqueada porque el grupo que trabajó en ella ahora está archivado.",
      "DISABLE_GROUP_INFO_MSG" : "Esta es una actividad colaborativa. Solo pueden completarla alumnos asignados a grupos por un profesor.",
      "POST_BUTTON" : "Publicar",
      "NO_COMMENTS_LABEL": "Ningún comentario aún",
      "YOUR_COMMENT_LABEL": "Tu comentario",
      "LOAD_MORE_COMMENTS": "Ver comentarios anteriores",
      "LOADING_COMMENTS": "Cargando",
      "ACTOR_TEACHER_LABEL": "Profesor",
      "ELAPSED_TIME": {
        "JUST_NOW": "Recién",
        "MINUTE_AGO": "hace 1 minuto",
        "MINUTES_AGO": "hace X minutos",
        "HOUR_AGO": "hace 1 hora",
        "HOURS_AGO": "hace X horas",
        "DAY_AGO": "hace 1 día",
        "DAYS_AGO": "hace X días"
      },
      "READY": "Listo",
      "SUBMIT": "Enviar",
      "SCREEN_READER": {
        "GROUP_INFO": "Información sobre el grupo",
        "CLOSE_GROUP_INFO": "Cerrar ventana emergente de información sobre el grupo",
        "SCROLL_BTN_UP": "Desplazar al tope",
        "SCROLL_BTN_DOWN": "Desplazar al pie",
        "INFO": "Información"
      },
      "ARE_YOU_READY_TO_SUBMIT": "¿Listo para entregar?",
      "NO_FURTHER_CHANGES_ALLOWED_MESSAGE": "Estás actuando en nombre de todos los integrantes del grupo. ¿Estás seguro de que esta actividad ya está completa?",
      "CANCEL": "Cancelar",
      "COMPLETE": "Sí, completa"
    },
    "CHANGES_NOT_SAVED": {
      "FORGIVE_US_TEXT": "Lamentablemente,",
      "SORRY_SOMETHING_WRONG_TEXT": "Lamentablemente, algo salió mal",
      "SORRY_PROBLEM_AT_OUR_END_TEXT": "Lamentablemente hubo un problema en nuestra plataforma. Vuelve a intentar más tarde",
      "SOMETHING_WENT_WRONG": "no podemos entregar tu trabajo en este momento.",
      "LAST_SAVED": "Última vez guardado",
      "PLEASE_TRY_AGAIN": "Verifica que estás en línea y vuelve a intentar",
      "OK": "OK",
      "RECORDING_NOT_SAVED": "Lamentablemente, no podemos guardar tu trabajo en este momento. No te preocupes; no perderás tu trabajo a menos que hagas click en el botón de Salir.",
      "CHECK_TIPS": "Intenta lo siguiente",
      "FREE_SPACE": "Verifica que estás en línea.",
      "TIPS2": "Haz espacio en tu dispositivo.",
      "PLEASE_CHECK_URL_LINK": "Verifica el URL agregado y vuelve a intentar"
    },
    "SAVEALERT": {
      "CLOSE": "Cerrar",
      "EXIT": "Sí, quiero salir de esta página",
      "STAY": "Permanecer en esta página",
      "LOOSE_WORK_WARNING_MESSAGE": "Si lo haces, perderás todo tu trabajo",
      "ARE_YOU_SURE": "¿Estás seguro de querer abandonar esta actividad?",
      "ARE_YOU_SURE_SCOMP": "Are you sure you want to leave?",
      "LOOSE_WORK_WARNING_MESSAGE_SCOMP": "You'll need to start again next time",
      "YES_LEAVE": "Yes, leave",
      "NO_STAY": "No, stay"
    },
    "COOKIES_BANNER": {
        "WEBSITE_USES_COOKIES": "Este sitio web utiliza cookies. Para más información, consulta",
        "PRIVACY_POLICY": "Aviso de privacidad",
        "ACCEPT": "Acepto cookies"
    },
    "RESULT_SCREEN": {
      "YOU_SCORED":"Tu puntaje fue",
      "MARKS_OUT_OF":"de",
      "CONTINUE": "Actividad siguiente",
      "REVIEW": "Revisar respuestas",
      "TRY_AGAIN": "Vuelve a intentar",
      "START_AGAIN": "Vuelve a intentar"
    },
    "GENERIC_LTI": {
      "PREVIEW_BUTTON": "Previsualizar",
      "LAUNCH_BUTTON" : "Iniciar",
      "REVIEW_BUTTON" : "Revisar",
      "LITMUS_TEST_INSTRUCTION": "We are making some changes to these tests, so they will look a little different. If you need help, you can find it on ",
      "CAMBRIDGE_ONE": "Cambridge One",
      "INSTRUCTIONS_MSG1": "Esta prueba ha sido diseñada para ordenador",
      "INSTRUCTIONS_MSG2": "Para ver las preguntas de esta prueba de <strong>{{activityName}}</strong>, selecciona ‘Vista Previa’, para que se abra una ventana nueva.",
      "INSTRUCTIONS_MSG3": "Cierra la ventana para volver aquí y asignar la prueba.",
      "INSTRUCTIONS_MSG4": "Close the window to return here and create a rule.",
      "INSTRUCTIONS_MSG5": "Close the window to return here and edit tests included in score calculation.",
      "LAUNCH_INSTRUCTIONS": "Para iniciar <strong>{{activityName}}</strong>, selecciona ‘Iniciar’ y se abrirá en una ventana nueva.",
      "SINGLE_ATTEMPT_INSTRUCTIONS": "Please be aware that you will only have <strong>one attempt</strong> to complete this test.",
      "REVIEW_INSTRUCTIONS" : "Para revisar <strong>{{activityName}}</strong>, selecciona ‘Revisar’ y se abrirá en una ventana nueva.",
      "REVIEW_LAST_ATTEMPT": "Para revisar tu último intento, selecciona ‘Revisar’ y se abrirá en una ventana nueva.",
      "PREVIEW_INSTRUCTIONS": "Para ver las preguntas de esta prueba de <strong>{{activityName}}</strong>, selecciona ‘Vista Previa’, para que se abra una ventana nueva.",
      "LOADER_TEXT": "Your page is loading. This might take a few seconds.",
      "LITMUS_DOWN_TEXT": "We can't take you to this task right now",
      "LITMUS_DOWN_MSG1": "Due to maintenance taking place this task is currently unavailable. Please try again later",
      "LITMUS_DOWN_MSG2": "Due to maintenance taking place this task is currently unavailable. You can still assign this test to a class",
      "LITMUS_DOWN_CLOSE": "Close",
      "LITMUS_DOWN_SCREEN_MSG1": "Due to maintenance taking place this task is currently unavailable. Please try again later",
      "LITMUS_DOWN_SCREEN_BUTTON": "Go to Dashboard",
      "LEARNER_REVIEW_ASSIGNMENT": {
        "INSTRUCTIONS" : "Revisa las respuestas de la última vez que intentaste <strong>{{activityName}}</strong>, y luego selecciona ‘Iniciar’ si deseas intentar la prueba nuevamente.",
        "LAST_ATTEMPT_INSTRUCTIONS": "Para revisar <strong>{{activityName}}</strong>, selecciona ‘Revisar’ y se abrirá en una ventana nueva.",
        "ATTEMPTS_LEFT" : {
          "NONE": "Ya no le quedan más intentos",
          "SINGULAR": "Te queda <strong>{{attemptsLeft}}</strong> intento",
          "PLURAL": "Te queda <strong>{{attemptsLeft}}</strong> intentos",
        },
        "PRACTICE_INSTRUCTIONS": "Revisa las respuestas de la última vez que intentaste <strong>{{activityName}}</strong>, y luego completa la práctica recomendada antes de intentar nuevamente esta prueba",
        "VIEW_RECOMMENDED_PRACTICE": "Ver práctica recomendada"
      },
      "BROWSER_NOT_SUPPORTED": {
        "HEADING": "Navegador incompatible",
        "DESCRIPTION": "No se puede iniciar esta prueba en Safari. Para hacerlo necesitarás usar Google Chrome",
        "CLOSE": "Close pop up for browser not supported",
        "CLOSE_BTN": "Cerrar"
      },
      "SCREEN_READER": {
          "PREVIEW_BUTTON": "Previsualizar",
          "LAUNCH_BUTTON" : "Iniciar",
          "REVIEW_BUTTON" : "Revisar",
          "DESIGNED_FOR_DESKTOP": "Designed for desktop img"
      },
    },
    "ATTEMPTS_EXCEEDED": {
      "ATTEMPT_LIMIT_MSG1": "Has repetido esta prueba todas las veces posibles",
      "ATTEMPT_LIMIT_MSG2": {
        "NONE": "Ya has repetido esta prueba las {{attemptAllowed}} veces posibles.",
        "SINGULAR": "Ya has intentado esta prueba la única vez posible.",
        "PLURAL": "Ya has repetido esta prueba las {{attemptAllowed}} veces posibles.",
      },
      "ATTEMPT_LIMIT_MSG3": "You have already used all the attempts available to you for this test.",
      "NAVIGATE_TO_DASHBOARD_BUTTON": "Ir al tablero",
    },    
    "AUDIO_PROMPT": {
        "FORWARD_BUTTON": "Avanzar 5 segundos",
        "REWIND_BUTTON": "Retroceder 5 segundos",
        "PLAY": "Reproducir",
        "PAUSE": "Pausar",
        "SCREEN_READER": {
            "PROGRESS_BAR": "Seek"
        }
    },
    "SUBMIT_REDIRECTION_PAGE": {
      "MY_HOMEWORK_BUTTON": "Volver a Mis deberes",
      "MY_ASSIGNMENTS_BUTTON": "Volver a Mis tareas",
      "HEADING_TEXT": "¡Felicitaciones!",
      "SUB_HEADING_1": "Has completado exitosamente <strong>{{testName}} (Intento № {{submitCount}})</strong>",
      "SUB_HEADING_2": "Te notificaremos cuando los resultados estén listos. Mientras tanto, ¡sigue aprendiendo!",
      "ATTEMPT_DESCRIPTION_1": "Ya no puedes volver a repetir esta prueba",
      "ATTEMPT_DESCRIPTION_2": "Después de esta vez te quedan <strong>{{remainingAttempt}}</strong> más",
      "GREEN_TICK_ICON": "Green tick icon"
    },
    "LO_RENDERER": {
      "BACK": "Atrás",
      "BACK_TO_ASSIGNMENT_SUMMARY": "Back to summary",
      "CANCEL": "Cancelar",
      "NO_ACTIVITY_PREVIEW_PART1": "Select options from the menu to create a rule",
      "NO_ACTIVITY_PREVIEW_PART2": "Click on any title to view the content",
      "CUSTOM_LINK_DELETION_SUCCESS": "Successfully deleted custom link",
      "EXPIRED_CLASS_BANNER": "Esta clase ha caducado. Podrás seguir viendo las actividades incluidas, sin embargo, no podrás realizar cambios.",
      "ENDED_CLASS_BANNER": "Esta clase ha terminado. Para poder editar las clases incluidas, debes reactivar primeramente la clase.",
      "DELETED_CLASS_BANNER":"Esta clase se eliminó. Todavía puede ver los parámetros para calificar la clase, pero no puede realizar cambios",
      "REACTIVATE": "Reactivar",
      "REACTIVATED_MESSAGE": "Clase reactivada hasta {{classEndDate}}",
      "REACTIVATE_CLASS_HEADING": "Reactivar la clase",
      "CHANGE_CLASS_NAME": "Cambiar el nombre de la clase",
      "CHANGE_STARTING_DATE": "Cambiar la fecha de inicio",
      "CHANGE_ENDING_DATE": "Cambiar la fecha de finalización",
      "CLASS_FORM_END_DATE_ERROR": "Es necesaria una fecha de finalización ",
      "CLASS_FORM_DATES_ERROR": "Parece que hay un error con estas fechas. Verifica y vuelve a intentar.",
      "CLASS_FORM_CHANGE_END_DATE_ERROR": "Prolongar la fecha de finalización para reactivar esta clase.",
      "REACTIVATION_PROGRESS_SYNCING_MESSAGE" : "La reactivación puede tardar, porque tenemos que sincronizar el progreso de sus alumnos para proporcionarle el panorama completo.",
      "WARNING_LEAVE_THIS_PAGE": "Are you sure you want to leave this page?",
      "WARNING_MODAL_TEXT": "All progress will be lost",
      "GO_BACK": "No, go back",
      "CONFIRM_LEAVE_THIS_PAGE": "Yes, leave this page",
      "SCREEN_READER": {
        "BACK": "Go Back",
        "CLOSE": "Cerrar",
        "TOGGLE_TOC": "Open table of contents",
        "CLOSE_ACTIVITY": "Close Activity",
        "NAVIGATE_TO_MANAGE_ACCESS": "Navigate to manage students access"
      },
      "TEACHER_TRAINING_MSG": "This course can be found in <strong>My training</strong>",
      "ASSIGNMENTS_ONLY_BANNER": {
        "DESC": "This material can only be completed by students when you unlock or assign it",
        "DONT_SHOW_AGAIN": "Don't show again",
        "CLOSE": "Close"
    }
    },
    "CONTENT_ACCESS": {
      "BACK": "Atrás",
      "RULE": {
        "CONTENT_LOCKED": "Contenido bloqueado",
        "NO_ACCESS": "No tienes acceso a esta actividad",
        "NO_ACCESS_ASSIGNMENT_ONLY_PRODUCT": "Este contenido te estará disponible cuando tu profesor te dé acceso",
        "TIME_RANGE_START": "Te volverá a estar disponible desde el <strong>{{startDate}} {{startTime}}</strong> ",
        "TIME_RANGE_END": "hasta el <strong>{{endDate}} {{endTime}}</strong>"
      },
      "SCREEN_READER": {
        "LOCKED": "bloqueado",
        "BACK": "Atrás"
      }
    },
    "SCOMP_VIEW": {
      "BACK": "Atrás",
      "CONTENT_ACCESS": {
        "CONTENT_LOCKED": "Contenido bloqueado",
        "NO_ACCESS": "No tienes acceso a esta actividad",
        "NO_ACCESS_ASSIGNMENT_ONLY_PRODUCT": "Este contenido te estará disponible cuando tu profesor te dé acceso",
        "TIME_RANGE_START": "Te volverá a estar disponible desde el <strong>{{startDate}} {{startTime}}</strong> ",
        "TIME_RANGE_END": "hasta el <strong>{{endDate}} {{endTime}}</strong>",
        "GO_BACK": "Atrás",
        "SCREEN_READER": {
          "CLOSE_POPUP": "Close popup",
          "LOCKED": "bloqueado"
        }
      }
    }
  },
  "HTML_META" : {
    'LEARNERLEARNINGPATH' : {
            'TITLE' : '| Cambridge One',
            'DESCRIPTION' : 'Choose an item to learn or pick up where you last left off.'
        },
      'TEACHERLEARNINGPATH' : {
          'TITLE' : '| Cambridge One',
          'DESCRIPTION' : 'View learning materials available for teaching your students.'
      },
    "LEARNINGPATH": {
      "TITLE": "| Cambridge One",
      "DESCRIPTION": "Elegir un tema para aprender o seguir con el tema que dejaste"
    },
    "MAIN": {
      'CUSTOM_TITLE' : ' | Cambridge One',
      "TITLE": "Cambridge One | Cambridge University Press",
      "DESCRIPTION": "Cambridge One es una plataforma de aprendizaje compatible con dispositivos móviles para estudiantes y docentes del idioma inglés."
    },
    'WARNING_MESSAGE': {
      'TITLE': 'Warning message - Exceeded attempts | Cambridge One'
    },
    'ASSIGNMENT_DETAILS': {
      'TITLE': 'Assignment details',
      'DESCRIPTION': 'Enter assignment details'
    },
    'CREATE_ASSIGNMENT': {
      'TITLE' : 'Create assignment',
      'DESCRIPTION': 'Select content to include in the assignment'
    },
    'CREATE_CUSTOM_LINK': {
      'TITLE' : 'Create content link of',
      'DESCRIPTION': 'Select content to include in the content link'
    },
    'SELECT_STUDENTS': {
      'TITLE': 'Select students',
      'DESCRIPTION': 'Select students for the assignment'
    },
    'ASSIGNMENT_SUMMARY': {
        'TITLE': 'Assignment summary',
        'DESCRIPTION': 'Check the assignment details you selected'
    },
    'EDIT_ASSIGNMENT': {
        'TITLE': 'Assignment summary',
        'DESCRIPTION': 'Edit the assignment'
    },
    'ASSIGNMENT_CONTENT': {
        'TITLE': 'Edit assignment',
        'DESCRIPTION': 'Select content to include in the assignment'
    },
    'CREATE_RULE': {
        "TITLE": "Create a rule for ",
        'DESCRIPTION': 'Select content to create an access rule'
    },
    'UPDATE_RULE': {
        'TITLE': 'Edit the rule for ',
        'DESCRIPTION': 'Select content for the access rule'
    },
    "SCOMP_PRODUCT": {
      "TITLE": "Speaking Companion",
      "DESCRIPTION": "Choose a topic to practice speaking English with Cambridge One AI speaking companion"
    },
    "SCOMP_ACTIVITIES": {
      "TITLE": "Speaking Companion activities",
      "DESCRIPTION": "Choose a topic to practice speaking English with Cambridge One AI speaking companion"
    },
    "SCOMP_ACTIVITY_VIEW": {
        "TITLE": "Speaking Companion | {{ActivityName}}",
        "DESCRIPTION": "Practice speaking English with Cambridge One AI Speaking Companion"
    }
  }
}
module.exports = Object.assign(translationJsonObj, translationJson);
